import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { TranslateService } from '@ngx-translate/core';

export enum SupportedLanguages {
  GERMAN = 'de',
  FRENCH = 'fr',
  ENGLISH = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly supportedLanguages: SupportedLanguages[] =
    Object.values(SupportedLanguages);
  private activeLanguage = new BehaviorSubject<SupportedLanguages>(
    SupportedLanguages.GERMAN,
  );
  activeLanguage$ = this.activeLanguage.asObservable();

  constructor(
    private authService: AuthService,
    private translateService: TranslateService,
  ) {
    // Setup Translation Service
    this.translateService.setDefaultLang(SupportedLanguages.GERMAN);
    translateService.addLangs(this.supportedLanguages);
    this.setActiveLanguage(SupportedLanguages.GERMAN);

    // Subscribe to language changes from the auth service
    this.authService.language$.subscribe((language) => {
      if (this.isSupportedLanguage(language))
        this.setActiveLanguage(language as SupportedLanguages);
    });
  }

  private isSupportedLanguage(language: string): boolean {
    return Object.values(SupportedLanguages).includes(
      language as SupportedLanguages,
    );
  }

  get languages(): SupportedLanguages[] {
    return this.supportedLanguages;
  }

  setActiveLanguage(language: SupportedLanguages) {
    try {
      if (this.isSupportedLanguage(language)) {
        this.activeLanguage.next(language);
        this.translateService.use(language);
      } else {
        console.warn(`Unsupported language: ${language}`);
      }
    } catch (error) {
      console.error('Error setting language:', error);
      this.activeLanguage.next(SupportedLanguages.GERMAN);
      this.translateService.use(SupportedLanguages.GERMAN);
    }
  }
}
